module.exports = __webpack_public_path__ + "static/media/crab.47e7a89f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/crab.svg
// module id = 617
// module chunks = 6